export default {
  meta: {
    title: '审批详情',
    url: '/approval/detail', // 埋点字段，上报归属的模块
    urlName: '审批' // 埋点字段，上报归属的模块
  }
};
